import { ref } from 'vue';

// 留电来源报表筛选状态持久化(定制 2026-08-26):
// 报表页筛选(日期/归属者/来源/域名)原存 Index.vue 组件本地, 离开报表页
// (点侧边栏其他菜单/标签)再切回来时组件重挂载 → 状态归零回"今天" →
// 客服反馈"自定义日期选好后固定不住, 会跳回当前日期, 每次都要重新选"。
// 提到模块级单例, 重挂载后恢复上次筛选(与名片管理 contactsFilterState 同思路)。
const pad = n => String(n).padStart(2, '0');
export const fmtReportDate = d =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// 默认"今天"(按北京时区算, 浏览器可能是 UTC)
const defaultTodayRange = () => {
  const now = new Date();
  const bj = new Date(
    now.getTime() + now.getTimezoneOffset() * 60000 + 8 * 3600000
  );
  return [
    new Date(bj.getFullYear(), bj.getMonth(), bj.getDate()),
    new Date(bj.getFullYear(), bj.getMonth(), bj.getDate(), 23, 59, 59),
  ];
};

const initRange = defaultTodayRange();

const state = {
  selectedOwners: ref([]), // 空 = 全部
  selectedSources: ref([]), // 空 = 全部
  selectedDomains: ref([]), // 空 = 全部
  customDateRange: ref(initRange),
  selectedRangeType: ref('today'),
  // 后端查询用的北京日期(YYYY-MM-DD)
  since: ref(fmtReportDate(initRange[0])),
  until: ref(fmtReportDate(initRange[1])),
};

export const initReportFilterState = () => {
  const range = defaultTodayRange();
  state.selectedOwners.value = [];
  state.selectedSources.value = [];
  state.selectedDomains.value = [];
  state.customDateRange.value = range;
  state.selectedRangeType.value = 'today';
  state.since.value = fmtReportDate(range[0]);
  state.until.value = fmtReportDate(range[1]);
};

initReportFilterState();

export const useReportFilterState = () => state;
